import { create } from 'zustand';
import type { PurchaseCompleteMessage } from '../purchase-complete.contract';

interface PurchaseCompleteState {
  expectedCorrelationId: string | null;
  payload: PurchaseCompleteMessage | null;
  beginWait: (correlationId: string) => void;
  accept: (payload: PurchaseCompleteMessage) => void;
  dismiss: () => void;
}

export const usePurchaseCompleteStore = create<PurchaseCompleteState>((set, get) => ({
  expectedCorrelationId: null,
  payload: null,

  beginWait: (correlationId) =>
    set({
      expectedCorrelationId: correlationId,
      payload: null,
    }),

  accept: (payload) => {
    const expected = get().expectedCorrelationId;
    if (!expected || payload.correlationId !== expected) return;
    set({ payload, expectedCorrelationId: null });
  },

  dismiss: () =>
    set({
      payload: null,
      expectedCorrelationId: null,
    }),
}));
